import { FormGroup, IFormGroupProps } from '@blueprintjs/core'
import React from 'react'
import CX from 'classnames'
import { isRequiredError, renderError, renderErrorExceptRequired, stylizeTitle } from './Helpers'

interface Props {
  title: string
  error?: string
  showRequiredLabel?: boolean
  requiredLabelString?: string
}

// For straightforward cases, this a good replacement for FormGroup.
// It handles concerns like the interaction between the "Required" label and the helper text (which we hide if it's basically saying "required").
// Other more complicated cases might reference this as an example, and leverage the helper functions here.
export const ProductFormGroup: React.FC<IFormGroupProps & Props> = ({
  title,
  error,
  showRequiredLabel,
  requiredLabelString,
  children,
  ...props
}) => {
  let labelInfo = null
  if (showRequiredLabel) {
    labelInfo = requiredLabelString || 'Required'
  }

  return (
    <FormGroup
      label={stylizeTitle(title, error)}
      labelInfo={isRequiredError(error) ? renderError(labelInfo) : labelInfo}
      helperText={renderErrorExceptRequired(error, labelInfo)}
      intent={error ? 'danger' : 'none'}
      {...props} // rare cases like InventoryLocationSelect need to pass in other attributes like disabled
      className={CX(props.className, 'float-right-formgroup-label')}
    >
      {children}
    </FormGroup>
  )
}
